import { Component, OnInit } from '@angular/core';
import { AuthService } from '@common/generic';
import { constants } from '@common/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-default-page',
  templateUrl: './default-page.component.html',
  styleUrls: ['./default-page.component.scss']
})
export class DefaultPageComponent implements OnInit {
  constructor(private auth: AuthService, private router: Router) {
    if (this.auth.inRole([constants.roles.SchemeOwner])) {
      this.router.navigate(['users']);
    } else if (
      this.auth.inRole([
        constants.roles.SchemeAdmin,
        constants.roles.User,
        constants.roles.SatelliteAdmin,
        constants.roles.PartyAdmin
      ])
    ) {
      this.router.navigate(['participants']);
    } else {
      this.router.navigate(['account', 'profile']);
    }
  }

  ngOnInit() {}
}
